import { render, staticRenderFns } from "./roll_stock.vue?vue&type=template&id=3badefef&scoped=true"
import script from "./roll_stock.vue?vue&type=script&lang=js"
export * from "./roll_stock.vue?vue&type=script&lang=js"
import style0 from "./roll_stock.vue?vue&type=style&index=0&id=3badefef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3badefef",
  null
  
)

export default component.exports